import { makeStyles } from '@mui/styles';

export const UseStyles = makeStyles({
  root: {
    '& .MuiTableHead-root .MuiTableCell-root': {
      fontWeight: 700,
    },
    '& .MuiTableRow-root .MuiTableCell-root': {
      wordBreak: 'break-word'
    }
  },
  lastRow: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
  }
});
